import React, { Suspense } from 'react';
import styled from 'styled-components';
import Input from '../input';
import spacer from '../spacer';

const DatePicker = React.lazy(() => import('./datepicker'));

const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  ${({ $noSpacer }) => !$noSpacer && spacer}

  > div {
    flex-grow: 1;
  }
`;

const DateInput = ({
  $noSpacer,
  placeholder,
  children,
  useDatePicker = false,
  minDate,
  maxDate,
  excludeDates,
  filterDate,
  highlightDates,
  ...props
}) => {
  const defaultInput = (
    <Input
      type="date"
      {...props}
      $noSpacer
    />
  );
  return (
    <Wrapper $noSpacer={$noSpacer}>
      {placeholder && (
        <label htmlFor={props.name}>{placeholder}:</label>
      )}
      <div>
        {useDatePicker && (
          <Suspense fallback={defaultInput}>
            <DatePicker
              {...props}
              minDate={minDate}
              maxDate={maxDate}
              excludeDates={excludeDates}
              filterDate={filterDate}
              highlightDates={highlightDates}
              onChange={props.onChange}
            >
              {children}
            </DatePicker>
          </Suspense>
        )}
        {!useDatePicker && defaultInput}
      </div>
    </Wrapper>
  );
};

export default DateInput;
